import styled from 'styled-components';

import AlertMessage from '../../../../components/AlertMessage';
import EmptyState from '../../../../components/EmptyState';
import { Button } from '@mui/material';


export const Wrapper = styled.div`
    height: auto;
    width: 100%;
    overflow: auto;
`;

export const NFList = styled.ul`
    display: flex;
    flex-direction: column;
    height: auto;
    width: 100%;
    margin: 0;
    padding: 16px;
    gap: 16px;
    list-style: none;
    background-color: var(--gray-lightest);
`;

export const AlertMessageStyled = styled(AlertMessage)`
height: 80px;
    margin: 24px 16px 24px 24px;
`;

export const EmptyStateStyled = styled(EmptyState)``;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  padding: 24px;
`;

export const WarningImage = styled.img`
  width: 60px;
  height: 60px;
`;

const DefaultButton = styled(Button)`
  width: 200px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  color: #FFF;
  background-color: var(--luft-primary);
  
  &:hover {
    background-color: var(--luft-primary-darker);
  }
`;


export const StyledButton = styled(DefaultButton)`
  && {
    background-color: var(--luft-primary);
    color: #fff;
    text-transform: none;
    display: flex;
    gap: 8px;

    &:hover {
      background-color: var(--luft-primary-darker);
    }
  }
`;

export const SearchResultContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const ClearSearchButton = styled(Button)`
  && {
    width: 160px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid rgba(38, 52, 101, 0.50);
    font-size: 14px;
    color: var(--luft-primary);
    font-weight: 500;
  }
`;

export const ChipContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
`;
